@if ((leverantorsOrganisationer$ | async); as leverantorsOrganisationer) {
  @if (leverantorsOrganisationer.length > 1) {
    <div class="vk-flex-item">
      <rask-pillbox theme="white-outline"
        [text]="selectedLabel">
        <rask-icon
          autoClose="outside"
          icon="far fa-edit"
          [clickToOpen]="true">
          <rask-simple-selector
            [clearable]="true"
            label="Leverantörs organisation"
            [formControl]="localControl"
            bindLabel="text"
            bindValue="value"
            [values]="leverantorsOrganisationer">
          </rask-simple-selector>
        </rask-icon>
      </rask-pillbox>
    </div>
  }
}